// extracted by mini-css-extract-plugin
export var closeButton = "_k5-2";
export var closeButtonIcon = "_k5-3";
export var lightboxContent = "_k5-1";
export var lightboxOverlay = "_k5-0";